<ul>
  @for (item of items(); let first = $first; track _trackBy($index, item)) {
    <li [class.spacing]="!first">
      <myre-menu-item [type]="type()" [item]="item">
        @if (item.children) {
          <myre-menu-items [items]="item.children" [type]="type()" />
        }
      </myre-menu-item>
    </li>
  }
</ul>
